// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AppBackground-root{position:absolute;background-color:#f2f7fd;z-index:-1;top:0;left:0;right:0;bottom:0;overflow:hidden}.AppBackground-cloud-left{position:absolute;left:4%;bottom:12%;z-index:-1}.AppBackground-cloud-right{position:absolute;right:1%;top:12%;z-index:-1}", ""]);
// Exports
module.exports = exports;
